import { RSAA } from 'redux-api-middleware';
import type { RSAAAction } from 'redux-api-middleware';
import { MANAGER_VIEW_APP_PREFIX, apiConfigHelper, locHrefUtil } from '@makemydeal/dr-shared-ui-utils';
import {
    FETCH_USER_PROFILE_REQUEST,
    FETCH_USER_PROFILE_SUCCESS,
    FETCH_USER_PROFILE_FAILURE
} from '../actionTypes/userProfileActionTypes';

export interface FetchUserProfilePayload {
    isEmployee: boolean;
    [key: string]: any;
}

export interface FetchUserProfileRequestAction {
    type: typeof FETCH_USER_PROFILE_REQUEST;
}

export interface FetchUserProfileSuccessAction {
    type: typeof FETCH_USER_PROFILE_SUCCESS;
    payload: FetchUserProfilePayload;
}

export interface FetchUserProfileFailureAction {
    type: typeof FETCH_USER_PROFILE_FAILURE;
    payload: {
        message: string;
    };
}

export type UserProfileAction = FetchUserProfileRequestAction | FetchUserProfileSuccessAction | FetchUserProfileFailureAction;

/**
 * Fetch user profile from the separate fetchUserProfile lambda
 * @returns RSAA action that triggers API call via redux-api-middleware
 */
export const fetchUserProfile = (): RSAAAction => {
    const locHref = locHrefUtil.getLocHref();
    const { url: endpoint } = apiConfigHelper.buildBffApiUrl(MANAGER_VIEW_APP_PREFIX, locHref, '/userProfile');

    return {
        [RSAA]: {
            endpoint,
            method: 'GET',
            headers: { 'content-type': 'application/json' },
            types: [FETCH_USER_PROFILE_REQUEST, FETCH_USER_PROFILE_SUCCESS, FETCH_USER_PROFILE_FAILURE]
        }
    };
};
